<template>
  <b-form-group
    label="Teslim Şekli"
    label-for="delivery_type"
  >
    <validation-provider
      #default="{ errors }"
      name="Teslim Şekli"
      rules="required"
    >
      <b-form-input
        id="delivery_type"
        v-model="dataItem.delivery_type"
        placeholder="Teslim Şekli"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { BFormGroup, BFormInput } from 'bootstrap-vue'
import { ValidationProvider, localize } from 'vee-validate'
import { required } from '@validations'

export default {
  name: 'DeliveryType',
  components: {
    BFormGroup,
    BFormInput,
    ValidationProvider,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['proformaInvoices/dataItem']
    },
  },
  created() {
    localize('tr')
  },
}
</script>
